import { JobSeekerPostalCode } from '../StepContent/JobSeeker/PostalCode'
import { Sex } from '../StepContent/Sex'
import { EmploymentStatus } from '../StepContent/EmploymentStatus'
import { CuisineGenre } from '../StepContent/CuisineGenre/CuisineGenre'
import { JobContent } from '../StepContent/JobContent/JobContent'
import { DetailedWorkDetails } from '../StepContent/DetailedWorkDetails'
import { JobSeekerContentConfirmation } from '../StepContent/JobSeeker/ContentConfirmation'
import { JobSeekerNameOnly } from '../StepContent/JobSeeker/BasicInformation/JobSeekerNameOnly'
import { JobSeekerBirthdayOnly } from '../StepContent/JobSeeker/BasicInformation/JobSeekerBirthdayOnly'
import { JobSeekerPasswordOnly } from '../StepContent/JobSeeker/BasicInformation/JobSeekerPasswordOnly'
import { JobSeekerCompanyNameOnly } from '../StepContent/JobSeeker/CompanyNameWithPeriod/JobSeekerCompanyNameOnly'
import { JobSeekerWorkPeriodOnly } from '../StepContent/JobSeeker/CompanyNameWithPeriod/JobSeekerWorkPeriodOnly'

// ステップ並び順は JobSeekerProgressBanner.tsx の getSegmentInfo のしきい値と対応。
// ステップの追加・並び替えを行う場合は両方修正すること。
export const getJobSeekerSteps = () => {
    return [
        { Component: Sex }, // 1
        { Component: JobSeekerPostalCode }, // 2 dot1進捗進める
        { Component: JobSeekerNameOnly }, // 3 dot1進捗進める
        { Component: JobSeekerBirthdayOnly }, // 4 dot1停止 (dot自体の画像を変更する) & 画像変更なし
        { Component: EmploymentStatus }, // 5 dot1停止 (dot自体の画像を変更する) & 画像変更あり
        { Component: JobSeekerCompanyNameOnly }, // 6 dot2進捗進める
        { Component: JobSeekerWorkPeriodOnly }, // 7 dot2進捗進める
        { Component: CuisineGenre }, // 8 dot2進捗進める
        { Component: JobContent }, // 9 dot2進捗進める
        { Component: DetailedWorkDetails }, // 10 dot2停止 (dot自体の画像を変更する) & 画像変更なし
        { Component: JobSeekerPasswordOnly }, // 11 dot2停止 (dot自体の画像を変更する) & 画像変更あり
        { Component: JobSeekerContentConfirmation }, // 12 dot2停止 (dot自体の画像を変更する) & 画像変更あり
    ]
}
